var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('header',[_c('h3',[_vm._v("会員登録")])])])],1),_c('loader',{attrs:{"loading":_vm.loading,"absolute":false}},[_vm._v(" "+_vm._s(_vm.loadingMessage)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }